import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Icon from '@ant-design/icons';

import './style.less';

const AntdFaIcon = ({ faIcon }) => {
  const svgIcon = () => <FontAwesomeIcon size="lg" icon={faIcon} />;

  return <Icon component={svgIcon} className="antd-icon-wrapper" />;
};

AntdFaIcon.propTypes = {
  faIcon: PropTypes.object.isRequired,
};

export default AntdFaIcon;
